export default "__VITE_PUBLIC_ASSET__b9a762a2__"